import { render, staticRenderFns } from "./omJobcard.vue?vue&type=template&id=ac62d4fa"
import script from "./omJobcard.ts?vue&type=script&lang=js&external"
export * from "./omJobcard.ts?vue&type=script&lang=js&external"
import style0 from "./omJobcard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports